import PropTypes from 'prop-types'

import { FormSection, Row, Col } from "twyne-new.ui"

import TabItem from "./TabItem"

const propTypes = {
  data: PropTypes.object,
  title: PropTypes.string,
}

export default function TabSection({ data, title }) {
  const dataParsed = Object.entries(data)
  return (
    <Col size='12'>
      <FormSection>{title}</FormSection>
      <Row>
        {dataParsed.map(([key, value], index) => <TabItem key={index} label={key} value={value} isBreakWord />)}
      </Row>
    </Col>
  )
}

TabSection.propTypes = propTypes
TabSection.defaultProps = {}
